/**
 * Janela de recebimento da central de notificações, em dias civis
 * (`aaaa-mm-dd`), para o filtro que vai ao servidor (`criadaDe`, `criadaAte`).
 *
 * Mesmas janelas da referência. As "Próximos N dias" ficam porque a referência
 * as tem; para aviso já recebido elas só encontram o de hoje.
 */
export interface Intervalo {
  de?: string;
  ate?: string;
}

const DIA = /^\d{4}-\d{2}-\d{2}$/;

/** Dia civil local, sem passar por UTC (meia-noite em São Paulo é 03h em UTC). */
export function diaCivil(data: Date): string {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

function somarDias(data: Date, dias: number): Date {
  return new Date(data.getFullYear(), data.getMonth(), data.getDate() + dias);
}

const valido = (valor: string): string | undefined => (DIA.test(valor) ? valor : undefined);

export function intervaloDoPeriodo(
  periodo: string,
  agora: Date,
  data = '',
  de = '',
  ate = '',
): Intervalo {
  const hoje = diaCivil(agora);

  switch (periodo) {
    case 'todos':
      return {};
    case 'hoje':
      return { de: hoje, ate: hoje };
    case 'mes':
      return {
        de: diaCivil(new Date(agora.getFullYear(), agora.getMonth(), 1)),
        ate: diaCivil(new Date(agora.getFullYear(), agora.getMonth() + 1, 0)),
      };
    case 'mesPassado':
      return {
        de: diaCivil(new Date(agora.getFullYear(), agora.getMonth() - 1, 1)),
        ate: diaCivil(new Date(agora.getFullYear(), agora.getMonth(), 0)),
      };
    case 'ano':
      return { de: `${agora.getFullYear()}-01-01`, ate: `${agora.getFullYear()}-12-31` };
    // Sem a data preenchida o recorte não filtra nada, em vez de esconder a lista.
    case 'data': {
      const dia = valido(data);
      return dia ? { de: dia, ate: dia } : {};
    }
    case 'intervalo':
      return { de: valido(de), ate: valido(ate) };
    default:
      break;
  }

  if (/^p\d+$/.test(periodo)) {
    return { de: hoje, ate: diaCivil(somarDias(agora, Number(periodo.slice(1)))) };
  }
  if (/^\d+$/.test(periodo)) {
    return { de: diaCivil(somarDias(agora, -Number(periodo))), ate: hoje };
  }
  return {};
}
